
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/safety-information",
      function () {
        return require("private-next-pages/safety-information.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/safety-information"])
      });
    }
  